import cuid from "cuid";
import { defaults, get, keyBy, map } from "lodash";
import { useEffect } from "react";
import { useLazyQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { KEYS, CONTACT_POINT_SYSTEM } from "utils/constants";
import Template from "../Template";
import View from "./View";

const AdherentAddress = ({
  project,
  tracer,
  currentStatus,
  onNext,
  onBack,
  updateUrl,
}) => {
  const subscriptionId =
    get(project, "fields.currentSubscription") ||
    localStorage.getItem(KEYS.SUBSCRIPTION_ID);

  const [getSubscription, { data }] = useLazyQuery(
    graphql.queries.SUBSCRIPTION,
  );

  useEffect(() => {
    if (subscriptionId)
      getSubscription({
        variables: { where: { id: subscriptionId } },
      });
  }, []);

  const telecoms = defaults(keyBy(get(project, "contact.telecoms"), "system"), {
    [CONTACT_POINT_SYSTEM.ZIP_CODE]: { value: null },
  });

  const next = ({ telecoms }) => {
    const mappedTelecoms = map(telecoms, (item, key) =>
      defaults(item, { id: cuid(), system: key }),
    );
    const source = localStorage.getItem(KEYS.SOURCE);
    updateUrl({
      subscriptionId,
      url: get(
        data,
        "subscription.insurancePlan.config.generatedUrl",
        `${process.env.REACT_APP_BASE_URL}/#/public/process/init/${source}`,
      ),
    });
    onNext({
      payload: {
        contact: {
          id: get(project, "contact.id"),
          telecoms: mappedTelecoms,
        },
      },
    });
  };

  const initialValues = {
    telecoms,
  };

  return (
    <Template
      onBack={onBack}
      project={project}
      progress={currentStatus.progress}
      contact={get(project, "contact")}
      HeaderComponent={{
        subscription: get(data, "subscription"),
        tracer,
        project,
        contact: get(project, "contact"),
      }}
      View={
        <View
          onNext={next}
          initialValues={initialValues}
          locked={get(data, "subscription.locked")}
          onBack={onBack}
        />
      }
    />
  );
};

export default AdherentAddress;
